import { render } from "./cloningRecord.vue?vue&type=template&id=0a891a54&scoped=true"
import script from "./cloningRecord.vue?vue&type=script&lang=js"
export * from "./cloningRecord.vue?vue&type=script&lang=js"

import "./cloningRecord.vue?vue&type=style&index=0&id=0a891a54&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a891a54"]])

export default __exports__